import React, { Component } from 'react'
import { ToastContainer } from 'react-toastr'
import { subscribe, unsubscribe } from '../../utils/pubsub'

export class Toastr extends Component {
  constructor (props) {
    super(props)
    this.showSuccessToastr = this.showToastr.bind(this, 'success')
    this.showInfoToastr = this.showToastr.bind(this, 'info')
    this.showWarningToastr = this.showToastr.bind(this, 'warning')
    this.showDangerToastr = this.showToastr.bind(this, 'error')
    this.subscriber = this.subscriber.bind(this)
    this.state = {
      token: null
    }
  }

  showToastr (type, data) {
    const msg = (typeof data === 'object') ? data.message || data[0] : data

    const defaultTitle = type.substring(0, 1).toUpperCase() + type.substring(1)
    const defaultOptions = {
      timeOut: 5000,
      showAnimation: 'animated fadeIn',
      hideAnimation: 'animated fadeOut'
    }

    const titleOverride = (typeof data === 'object') ? data.title || defaultTitle : defaultTitle
    const optionsOverride = (typeof data === 'object') ? data.options || defaultOptions : defaultOptions
    if (msg.match(/The tax registration number cannot be verified against the authorised HMRC account/)) {
      this.toastr[type](<div>
        <p>
        The tax registration number cannot be verified against the authorised HMRC account.<br />
        Please check the following:<br />
         1. The Tax registration number is entered correctly.<br />
         2. You have switched your HMRC account over to Making Tax Digital. Please refer to HMRC guidance. <br />
         3. You have the correct administrator rights on your Making Tax Digital HMRC account to complete authentication. <br />
         4. Please reauthorise Business Tax Portal with HMRC if required through the authorisation page.
        </p></div>, titleOverride, optionsOverride)
    } else {
      this.toastr[type](<div>{msg}</div>, titleOverride, optionsOverride)
    }
  }

  subscriber (msg, data) {
    if (msg === 'toastr.success') {
      this.showSuccessToastr(data)
    } else if (msg === 'toastr.info') {
      this.showInfoToastr(data)
    } else if (msg === 'toastr.warning') {
      this.showWarningToastr(data)
    } else if (msg === 'toastr.danger') {
      this.showDangerToastr(data)
    }
  }

  componentDidMount () {
    this.setState({
      token: subscribe('toastr', this.subscriber)
    })
  }

  componentWillUnmount () {
    unsubscribe(this.state.token)
  }

  render () {
    return <ToastContainer ref={ref => (this.toastr = ref)} className='toast-top-center' />
  }
}
